"use strict";

const sliderConfigs = {
    ".zwssgr-slider-1": { slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 3, slidesPerGroup: 3 }, 768: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } } },
    ".zwssgr-slider-2": { slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 3, slidesPerGroup: 3 }, 768: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } } },
    ".zwssgr-slider-3": { slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } } },
    ".zwssgr-slider-4": { slidesPerView: 1, slidesPerGroup: 1 },
    ".zwssgr-slider-5": { slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } } },
    ".zwssgr-slider-6": { slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 3, slidesPerGroup: 3 }, 768: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } } },
    ".zwssgr-slider-7": { slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } } },
    ".zwssgr-slider-8": { slidesPerView: 1, slidesPerGroup: 1 },
};

// Store Swiper instances
let swiperInstances = {};

function initializeSwipers() {
    Object.keys(sliderConfigs).forEach(selector => {
        const sliderElements = document.querySelectorAll(selector);

        if (sliderElements.length > 0) {
            // Create a unique identifier for each slider instance
            sliderElements.forEach((sliderElement, index) => {
                // Get the parent container for this specific slider
                const parentElement = sliderElement.closest('.zwssgr-slider');
                if (!parentElement) return;
                
                const slideCount = sliderElement.querySelectorAll('.swiper-slide').length;
                const config = sliderConfigs[selector];
                const minSlidesRequired = (config.slidesPerView || 1) + 1;
                const enableLoop = slideCount >= minSlidesRequired;
                
                // Create a unique key for this specific slider instance
                const uniqueKey = `${selector}-${index}`;
                
                // Find navigation elements specific to this slider instance
                const nextButton = parentElement.querySelector('.swiper-button-next');
                const prevButton = parentElement.querySelector('.swiper-button-prev');
                
                // Initialize this specific slider instance
                swiperInstances[uniqueKey] = new Swiper(sliderElement, {
                    slidesPerView: config.slidesPerView,
                    slidesPerGroup: config.slidesPerGroup,
                    spaceBetween: 20,
                    loop: enableLoop,
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    breakpoints: config.breakpoints || {},
                });
            });
        }
    });
}

function reinitializeAllSwipers(container) {
    if (!(container instanceof HTMLElement)) {
        console.error(`Invalid container element!`, container);
        return;
    }

    // First, destroy all existing swiper instances in this container
    Object.keys(swiperInstances).forEach(key => {
        if (swiperInstances[key] && swiperInstances[key].destroy) {
            swiperInstances[key].destroy(true, true);
            delete swiperInstances[key];
        }
    });

    // Then reinitialize all sliders in the container
    Object.keys(sliderConfigs).forEach(selector => {
        const sliderElements = container.querySelectorAll(selector);

        sliderElements.forEach((sliderElement, index) => {
            // Get the parent container for this specific slider
            const parentElement = sliderElement.closest('.zwssgr-slider');
            if (!parentElement) return;
            
            const slideCount = sliderElement.querySelectorAll('.swiper-slide').length;
            const config = sliderConfigs[selector];
            const minSlidesRequired = (config.slidesPerView || 1) + 1;
            const enableLoop = slideCount >= minSlidesRequired;
            
            // Create a unique key for this specific slider instance
            const uniqueKey = `${selector}-${index}-reinit`;
            
            // Find navigation elements specific to this slider instance
            const nextButton = parentElement.querySelector('.swiper-button-next');
            const prevButton = parentElement.querySelector('.swiper-button-prev');
            
            // Initialize this specific slider instance
            swiperInstances[uniqueKey] = new Swiper(sliderElement, {
                slidesPerView: config.slidesPerView,
                slidesPerGroup: config.slidesPerGroup,
                spaceBetween: 20,
                loop: enableLoop,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: config.breakpoints || {},
            });
        });
    });
}

// Export functions and sliderConfigs
export { initializeSwipers, reinitializeAllSwipers, sliderConfigs };


document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    initializeSwipers();

});